"use strict";

var _xBigint = require("@polkadot/x-bigint");
var _xGlobal = require("@polkadot/x-global");
// Copyright 2017-2023 @polkadot/x-bigint authors & contributors
// SPDX-License-Identifier: Apache-2.0

(0, _xGlobal.exposeGlobal)('BigInt', _xBigint.BigInt);